import React from "react";
import PropTypes from "prop-types";
import { format } from "date-fns";
import { useTheme, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  // 🎯 Keyframes para animações suaves
  "@keyframes fadeInUp": {
    "0%": {
      opacity: 0,
      transform: "translateY(10px)",
    },
    "100%": {
      opacity: 1,
      transform: "translateY(0)",
    },
  },
  
  "@keyframes shimmer": {
    "0%": {
      backgroundPosition: "-200px 0",
    },
    "100%": {
      backgroundPosition: "200px 0",
    },
  },
  
  // 🎯 Container com animação de entrada
  separatorContainer: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
    padding: "0 16px",
    animation: "$fadeInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
  },
  
  // 🎯 Chip moderno com micro-interações
  separatorChip: {
    position: "relative",
    borderRadius: "20px",
    padding: "10px 18px",
    fontSize: "0.85em",
    fontWeight: "500",
    textAlign: "center",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    cursor: "default",
    overflow: "hidden",
    
    // Efeito de brilho sutil
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: "-200px",
      width: "200px",
      height: "100%",
      background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
      animation: "$shimmer 3s infinite",
      zIndex: 1,
    },
    
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
    },
  },
  
  // 🎯 Texto com z-index para ficar acima do shimmer
  chipText: {
    position: "relative",
    zIndex: 2,
  },
}));

const TicketSeparator = ({ ticketId, status, createdAt, themeColors = {} }) => {
  const theme = useTheme();
  const classes = useStyles();

  // Pegar a cor primária configurada no sistema
  const primaryColor = theme.palette.primary.main || "#1976d2";
  
  const formattedDate = createdAt ? format(new Date(createdAt), "dd/MM/yyyy HH:mm") : "Data inválida";

  return (
    <div className={classes.separatorContainer}>
      <div
        className={classes.separatorChip}
        style={{
          backgroundColor: `${primaryColor}15`,
          border: `1px solid ${primaryColor}30`,
          color: theme.palette.text.primary,
          boxShadow: `0 2px 8px ${primaryColor}20`,
        }}
      >
        <span className={classes.chipText}>
          Ticket {String(ticketId || "N/A")} criado em {formattedDate}
        </span>
      </div>
    </div>
  );
};

TicketSeparator.propTypes = {
  ticketId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  status: PropTypes.string,
  createdAt: PropTypes.string,
  themeColors: PropTypes.object,
};

TicketSeparator.defaultProps = {
  ticketId: "N/A",
  status: "unknown",
  createdAt: null,
  themeColors: {},
};

export default TicketSeparator;
